import type { InsightKey } from "@tandemdiabetes/sugarmate-api-react-client"
import classNames from "classnames"
import type {
  ForwardedRef,
  HTMLAttributes,
} from "react"
import { forwardRef } from "react"
import styles from "./Tile.module.scss"
import { usePolyglot } from "src/contexts"

interface Props extends HTMLAttributes<HTMLDivElement> {
  insightKey: InsightKey;
}

export const TileTitle = forwardRef<HTMLDivElement, Props>(
  function TileTitle(props: Props, ref: ForwardedRef<HTMLDivElement>) {
    const {
      insightKey,
      ...divProps
    } = props

    const polyglot = usePolyglot()
    const className = classNames(
      props.className,
      styles.title,
    )

    return (
      <div
        {...divProps}
        ref={ref}
        className={className}
        id={`${insightKey}`}
      >
        {props.children}
        {polyglot.t(`pages.home.insights.title.HYPHENATE_${insightKey}`)}
      </div>
    )

  },
)
